import React from "react";
import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";
/*istanbul ignore next */
function CheckBox(props) {
  const { item, defaultValue, isRequired, isBgImage } = props;
  const onNotRequired = defaultValue
    ? "xfdlcheckbox-filled"
    : "xfdlcheckbox-empty";
  const onNotReq = defaultValue ? "black" : "blue";

  // Helper function to safely parse dimension values
  const parseDimension = (value) => {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      const parsed = Number.parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  };

  // Calculate dimensions - make slightly smaller for white background checkboxes
  const width = parseDimension(item.Width);
  const height = parseDimension(item.Height);
  const adjustedWidth = isBgImage ? width : Math.max(width - 2, 0);
  const adjustedHeight = isBgImage ? height : Math.max(height - 2, 0);

  // Only apply white background if there's no background image (checkbox doesn't exist in form)
  const checkboxStyle = {
    borderRadius: "0px",
    width: adjustedWidth > 0 ? `${adjustedWidth}px` : item.Width,
    height: adjustedHeight > 0 ? `${adjustedHeight}px` : item.Height,
    position: "absolute",
    top: `${parseDimension(item.SetTop)}px`,
    left: `${parseDimension(item.SetLeft)}px`,
  };

  // Add white background only if there's no background image with existing checkbox
  if (!isBgImage) {
    checkboxStyle.backgroundColor = "white";
  }

  // When there's a background image with existing checkbox, make it completely transparent
  const sxProps = isBgImage
    ? {
        color: "transparent",
        "&.Mui-checked": {
          color: "transparent",
        },
        "& .MuiSvgIcon-root": {
          opacity: 0,
        },
      }
    : {
        color: isRequired ? "red" : onNotReq,
      };

  return (
    <Checkbox
      type="checkbox"
      title={item.ToolTip?.Content || ""}
      name={item.Name}
      checked={defaultValue === "true" ? true : false}
      onChange={(e) => {
        props.checkBoxHandler(e, item.Name, isRequired);
      }}
      className={isRequired ? "xfdlcheckbox-req" : onNotRequired}
      disableRipple
      sx={sxProps}
      style={checkboxStyle}
      disabled={props.isDisabled}
    />
  );
}

CheckBox.propTypes = {
  item: PropTypes.shape({
    ToolTip: PropTypes.shape({
      Content: PropTypes.string,
    }),
    Name: PropTypes.string.isRequired,
    Width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  defaultValue: PropTypes.string,
  isRequired: PropTypes.bool,
  checkBoxHandler: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isBgImage: PropTypes.bool,
};

CheckBox.defaultProps = {
  defaultValue: "false",
  isRequired: false,
  isDisabled: false,
  isBgImage: false,
};

export default CheckBox;
